export const platformStatuses = {
    ACTIVE: 'active',
    UNINSTALLING: 'uninstalling',
}

export const PLATFORMS = {
    bigcommerce: 'BigCommerce',
}
